import { Col, Row, Select } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { StyledGroup, StyledInput } from '../../../../common-components/Input';
import { ContentSmallCamptonBook } from '../../../../layout/globalFonts';
import { isNativeApp, openLicensePlateScanner } from '../../../../utils/wrapperAppFunctions';

import useStore from '../../../../hooks/useStore';
import { ReactComponent as CameraIcon } from '../../../../layout/icons/camera-button.svg';
import { ReactComponent as CheckIcon } from '../../../../layout/icons/check.svg';
import { ReactComponent as DropdownArrow } from '../../../../layout/icons/small-arrow-collapsed.svg';
import ContentStore from '../../../../stores/ContentStore';

const LicensePlateInput = styled(StyledInput)`
  width: 70% !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
`;

interface LicensePlateFieldProps {
  licensePlate: string;
  setNewLicensePlate: (value: string) => void;
  disabled?: boolean;
  onChange?: (countryCode: string, licensePlate: string) => void;
}

export const LicensePlateField: React.FC<LicensePlateFieldProps> = observer(
  ({ licensePlate, setNewLicensePlate, disabled, onChange }) => {
    const { cmsStore, genericContentStore } = useStore(ContentStore) as ContentStore;
    const [countryCode, setNewCountryCode] = React.useState('DK');

    React.useEffect(() => {
      if (onChange) {
        onChange(countryCode, licensePlate);
      }
    }, [countryCode, licensePlate]);

    return (
      <Row align="middle" gutter={24}>
        <Col span={isNativeApp() ? 20 : 24}>
          <ContentSmallCamptonBook>
            <StyledGroup compact displayFlex style={{ marginBottom: '0px' }}>
              <Select
                style={{ width: '30%', textAlign: 'left' }}
                defaultValue={countryCode}
                getPopupContainer={(trigger) => trigger}
                menuItemSelectedIcon={<CheckIcon />}
                suffixIcon={<DropdownArrow />}
                onChange={(value: string) => setNewCountryCode(value)}
              >
                {genericContentStore.privateLicensePlateOrderIsoCodes.map((country) => (
                  <Select.Option value={country} key={country}>
                    <span style={{ paddingLeft: '5px' }}>{country}</span>
                  </Select.Option>
                ))}
              </Select>
              <LicensePlateInput
                placeholder={cmsStore.getContent('EnterLicensePlate')?.content}
                maxLength={10}
                onChange={(e) => setNewLicensePlate(e.target.value.toUpperCase())}
                value={licensePlate}
                disabled={disabled ?? false}
                style={{ textAlign: 'left' }}
              />
            </StyledGroup>
          </ContentSmallCamptonBook>
        </Col>
        {isNativeApp() && (
          <Col span={4} style={{ height: '32px' }}>
            <CameraIcon onClick={() => openLicensePlateScanner()} />
          </Col>
        )}
      </Row>
    );
  }
);

export default LicensePlateField;
